import { Controller } from "@hotwired/stimulus"

// Универсальный <dialog>: триггер и <dialog data-dialog-target="dialog">
// должны быть внутри одного data-controller="dialog".
export default class extends Controller {
  static targets = ["dialog"]

  open() {
    this.dialogTarget.showModal()
  }

  close() {
    this.dialogTarget.close()
  }

  closeOnBackdrop(event) {
    if (event.target === this.dialogTarget) this.dialogTarget.close()
  }
}
